import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minSlider", "maxSlider", "minInput", "maxInput", "track", "form"]

  connect() {
    this.updateTrack()
  }

  updateFromSlider(event) {
    const minVal = parseInt(this.minSliderTarget.value)
    const maxVal = parseInt(this.maxSliderTarget.value)

    if (maxVal - minVal < this.getStep()) {
      if (event && event.target === this.minSliderTarget) {
        this.minSliderTarget.value = maxVal - this.getStep()
      } else {
        this.maxSliderTarget.value = minVal + this.getStep()
      }
    }

    this.minInputTarget.value = this.minSliderTarget.value
    this.maxInputTarget.value = this.maxSliderTarget.value

    this.updateTrack()
  }

  updateFromInput(event) {
    if (event && event.target.value === "") return

    const min = parseInt(this.minSliderTarget.min)
    const max = parseInt(this.minSliderTarget.max)
    let minVal = parseInt(this.minInputTarget.value)
    let maxVal = parseInt(this.maxInputTarget.value)

    if (!isNaN(minVal)) {
      this.minSliderTarget.value = Math.max(min, Math.min(max, minVal))
    }
    if (!isNaN(maxVal)) {
      this.maxSliderTarget.value = Math.max(min, Math.min(max, maxVal))
    }

    this.updateTrack()
  }

  finalizeInput(event) {
    const min = parseInt(this.minSliderTarget.min)
    const max = parseInt(this.minSliderTarget.max)
    let minVal = parseInt(this.minInputTarget.value) || min
    let maxVal = parseInt(this.maxInputTarget.value) || max

    if (minVal < min) minVal = min
    if (maxVal > max) maxVal = max

    if (minVal > maxVal) {
      if (event && event.target === this.minInputTarget) {
        minVal = maxVal
      } else {
        maxVal = minVal
      }
    }

    this.minInputTarget.value = minVal
    this.maxInputTarget.value = maxVal
    this.minSliderTarget.value = minVal
    this.maxSliderTarget.value = maxVal

    this.updateTrack()
  }

  updateTrack() {
    const min = parseInt(this.minSliderTarget.min)
    const max = parseInt(this.minSliderTarget.max)
    const minVal = parseInt(this.minSliderTarget.value)
    const maxVal = parseInt(this.maxSliderTarget.value)

    if (max - min === 0) return

    const percentMin = ((minVal - min) / (max - min)) * 100
    const percentMax = ((maxVal - min) / (max - min)) * 100

    this.trackTarget.style.left = percentMin + "%"
    this.trackTarget.style.width = (percentMax - percentMin) + "%"
  }

  getStep() {
    return parseInt(this.minSliderTarget.step) || 1
  }
}